export enum OAuthProviderType {
    Msa = 'Msa',
    TeamSnap = 'TeamSnap',
    MsaInt = 'MsaInt',
    Google = 'Google',
}

export enum ConnectedAccountState {
    Active = 'Active',
    Revoked = 'Revoked',
    Error = 'Error',
}
